#import "../fragments/license-info-fragment.graphql"

query GetLicenseOverview {
    licenseOverview {
        instanceLicenses {
            ...LicenseInfoFragment
        }
    }
}
